import React, { useState, useContext, useEffect } from "react";
import { confirmDialog } from "primereact/confirmdialog";
import { Checkbox } from "primereact/checkbox";

import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";

import { AgregarAuth, getAutorizacionesPases } from "../../../../API/Logistica/PasesSalidaRequest";
import { toastShow } from "../../../../Base/Services/ToastService";
import PasesSalidaReporte from "./PasesSalidaReporte";

const ListadoPasesEnc = ({ listadoEnc, selectedEnc, setSelectedEnc, Firma, toast, getInfo, setShowDialog, Referencia}) => {
  const { userAuth } = useContext(AuthContext);
  const [Autorizaciones, setAutorizaciones] = useState([]);
  const [AutorizacionesIds, setAutorizacionesIds] = useState([]);
  const [showReporte, setShowReporte] = useState(false);
  const [selectedReporte, setSelectedReporte] = useState(null);


  const [firmarAutoriza, setFirmarAutoriza] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(50));
  const [firmarSeguridad, setFirmarSeguridad] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(51));
  const [firmarBodega, setFirmarBodega] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(52));
  const [firmarFinanzas, setFirmarFinanzas] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(53));

  const obtenerAutorizaciones = async ()=> {
    const autorizacionesData = await getAutorizacionesPases();
    setAutorizaciones(autorizacionesData)
    setAutorizacionesIds(autorizacionesData.map(i=> i?.IdPermisoGeneral))
  }

  // CAMBIAR FIRMAS DE FINANZAS Y GERENTE PLANTA 
  const agregarFirma = async (event, data, IdPermisoGeneral, NombrePermiso) => {
    const dataToSend = data.map((item) => {
      return {
        IdPase: item?.IdPase,
        IdPermisoGeneral: IdPermisoGeneral,
        Autorizo: !item[NombrePermiso],
        IdUserAutorizo: userAuth?.IdUser
      }
    });
    confirmDialog({
        message: `¿Está seguro que desea liberar ${data.length} ${data.length > 1 ? 'permisos' : 'permiso'}?`,
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        accept: async() => {
          const respuestaDetalles = await AgregarAuth(dataToSend);
          if (respuestaDetalles[0]?.ESTADO === 1) {
            toastShow(toast,"success", "Guardado", respuestaDetalles[0].MENSAGE);
            getInfo()
          } else {
            toastShow( toast, "error", "Error", respuestaDetalles[0].MENSAGE);
          }
        },
        reject: () => {}
    });
    setSelectedEnc([]);
  };


  const columns = [
    {
      field: "IdPase",
      header: "ID",
      headerEn: "ID",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "FechaCreacionStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      frozen: true,
      className: 'small'
    },
    {
      field: "NoPaseSalida",
      headerEn: "No. Pase",
      header: "No. Pase",
      className: "small",
      body: (rowData) => rowData.NoPaseSalida,
      Format: "Modal",
      frozen: true,
      Sumary: "count",
      onCellDoubleClicked: ({ data }) => {
        AbrirPase(data);
      },
      filter: false,
      initialFilterModel: true
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      headerEn: "Status",
      className: "small",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
      align: "center",
      Format: "Estado",
    },
    {
      field: "Motivo",
      header: "Motivo",
      headerEn: "Motivo",
      className: "XXlarge",
    },
    {
      headerName: "Vehículo",
      headerNameEn: "Vehicle",
      children: [
        {
          field: "Marca",
          header: "Marca",
          headerEn: "Marca",
          className: "medium",
        },
        {
          field: "Placa",
          header: "Placa",
          headerEn: "Placa",
          className: "medium",
        },
        {
          field: "ColorEs",
          header: "Color",
          headerEn: "Color",
          className: "medium",
        },
      ],
    },
    {
      field: "NombreCompletoMotorista",
      header: "Motorista",
      headerEn: "Driver",
      className: "large",
      body: (rowData) => rowData.NombreCompletoMotorista,
    },
    {
      field: "Identificacion",
      header: "Identificacion",
      headerEn: "ID",
      className: "small",
    },
    {
      field: "Area",
      header: "Área",
      headerEn: "Area",
      className: "small",
    },
    {
      field: "UserNameSolicita",
      header: "Solicita",
      headerEn: "Request",
      className: "medium",
    },
    {
      field: "UserNameCreate",
      header: "Usuario Creación",
      headerEn: "User Create",
      className: "medium",
      body: (rowData) => rowData.UserNameCreate,
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
      className: "XXlarge",
      body: (rowData) => rowData.Comment,
    },

    // USUARIOS FIRMAS
    AutorizacionesIds.includes(11) ?
    {
      headerName: "Firma Solicita",
      children: [
        {
          field: "UserNameAutorizo",
          header: "Usuario",
          headerEn: "User",
          className: "small",
        },
        {
          field: "FechaAutorizo",
          header: "Fecha",
          className: "small",
          headerEn: "Date",
          Format: 'DateTime2'
        },
      ],
    } : null,
    AutorizacionesIds.includes(12) ?
    {
      headerName: "Firma Bodega",
      children: [
        {
          field: "UserNameAutorizoBodega",
          header: "Usuario",
          headerEn: "User",
          className: "small",
        },
        {
          field: "FechaAutorizoBodega",
          header: "Fecha",
          className: "small",
          headerEn: "Date",
          Format: 'DateTime2'
        },
      ],
    } : null,
    AutorizacionesIds.includes(13) ?
    {
      headerName: "Firma Finanzas",
      children: [
        {
          field: "UserNameAutorizoFinanzas",
          header: "Usuario",
          headerEn: "User",
          className: "small",
        },
        {
          field: "FechaAutorizoFinanzas",
          header: "Fecha",
          className: "small",
          headerEn: "Date",
          Format: 'DateTime2'
        },
      ],
    } : null,
    AutorizacionesIds.includes(14) ?
    {
      headerName: "Firma Seguridad",
      children: [
        {
          field: "UserNameAutorizoSeguridad",
          header: "Usuario",
          headerEn: "User",
          className: "small",
        },
        {
          field: "FechaAutorizoSeguridad",
          header: "Fecha",
          headerEn: "Date",
          Format: 'DateTime2',
          className: "small",
        },
      ],
    } : null,

    {
      field: "IdPase",
      header: "",
      Format: "Botones",
      filter: false,
      hidden: !Firma,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-print",
          tooltip: "Reporte",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdPase) {
              setShowReporte(true)
              setSelectedReporte(rowData)
            }
          },
        },
      ],
    },

    ...Autorizaciones.map((autorizacion) => {
      const canAuthorize =
        (autorizacion?.IdPermisoGeneral === 11 && firmarAutoriza) || // Autoriza
        (autorizacion?.IdPermisoGeneral === 10 && firmarSeguridad) || // Seguridad
        (autorizacion?.IdPermisoGeneral === 12 && firmarBodega) || // Bodega
        (autorizacion?.IdPermisoGeneral === 13 && firmarFinanzas); // Finanzas

      const isHidden = canAuthorize && Firma === 1;

      return {
        field: autorizacion?.NombrePermiso,
        header: autorizacion.NombrePermiso,
        frozen: true,
        alignFrozen: "right",
        align: "center",
        className: "Xsmall",
        Format: "Template",
        filter: false,
        hidden: isHidden,
        body: (rowData) => {
          return rowData.IdPase ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "2px",
              }}
            >
              <Checkbox
                checked={rowData[autorizacion?.NombrePermiso] === 1}
                onChange={(event) => {
                  if (selectedEnc.length === 0) {
                    agregarFirma(
                      event,
                      [rowData],
                      autorizacion?.IdPermisoGeneral,
                      autorizacion.NombrePermiso
                    );
                  } else {
                    agregarFirma(
                      event,
                      selectedEnc,
                      autorizacion?.IdPermisoGeneral,
                      autorizacion.NombrePermiso
                    );
                  }
                }}
              />
            </div>
          ) : null;
        },
      };
    }),

  ];

  const AbrirPase = (data) => {
    setSelectedEnc(data);
    setShowDialog(true);
    // showModal('ingreso'); 
  };

  const table = {
    Columns: columns,
    Data: listadoEnc,
    showModal: (e) => showModal(e),
    key: "IdPase",
    selected: selectedEnc,
    setSelected: (e) => setSelectedEnc(e),
    initialFilterModel: Referencia
    ? {
        NoPaseSalida: {
          type: 'equals',
          filter: Referencia,
        },
    }
    : null,
  };


  const showModal = (PurchaseRequest) => {
    // setPurchaseShow(PurchaseRequest);
    // setRequisaDialog(true);
  };


  useEffect(() => {
    obtenerAutorizaciones();
  }, [Firma]);


  return (
    <div style={{width: "100%"}}>
      <div style={{ height: "83vh" }}>
        <AgGrid table={table} />
      </div>

      {showReporte && (
        <PasesSalidaReporte
          showReporte={showReporte}
          setShowReporte={setShowReporte}
          selectedReporte={selectedReporte}
          setSelectedReporte={setSelectedReporte}
        />
      )}
    </div>
  );
};

export default ListadoPasesEnc;
